import React from 'react';

import classNames from 'classnames';

import defaultLogo from './defaultLogo.svg';

import './DefaultLogo.scss';

const DEFAULT_SIZE = 'medium';

const DefaultLogo = ({
  size = DEFAULT_SIZE,
  className,
}: {
  size?: string;
  className?: string;
}) => {
  const logoSizeClass = `DefaultLogo--${size}`;
  const logoClassName = classNames(
    'DefaultLogo',
    { [logoSizeClass]: !!size },
    className,
  );

  return <img className={logoClassName} src={defaultLogo} alt="Flywire" />;
};

export { DefaultLogo };
